<template>
  <div class="data-privacy">
    <!--HEADER-->
    <!--HEADER-->
    <header class="header--small"></header>
    <!-- SECTION-->
    <section class="section my-5">
      <mdb-container>
        <mdb-row>
          <mdb-col class="d-flex justify-content-center">
            <h2 class="section__heading">Datenschutzerklärung</h2>
          </mdb-col>
        </mdb-row>
        <mdb-row class="mt-4 justify-content-center">
          <mdb-col md="10">
            <h3 class="isi-heading-gray mb-4">1. Datenschutz auf einen Blick</h3>
            <h4 class="isi-sub-heading-gray">Allgemeine Hinweise</h4>
            <p class="ml-0 mb-4">
              Die folgenden Hinweise geben einen einfachen Überblick darüber,
              was mit Ihren personenbezogenen Daten passiert, wenn Sie unsere
              Website besuchen. Personenbezogene Daten sind alle Daten, mit
              denen Sie persönlich identifiziert werden können. Ausführliche
              Informationen zum Thema Datenschutz entnehmen Sie unserer unter
              diesem Text aufgeführten Datenschutzerklärung.
            </p>
            <h4 class="isi-sub-heading-gray">
              Wer ist verantwortlich für die Datenerfassung auf dieser Website?
            </h4>
            <p class="ml-0 mb-4">
              Die Datenverarbeitung auf dieser Website erfolgt durch den
              Websitebetreiber. Dessen Kontaktdaten können Sie dem Impressum
              dieser Website entnehmen.
            </p>
            <h4 class="isi-sub-heading-gray">Wie erfassen wir Ihre Daten?</h4>
            <p class="ml-0 mb-4">
              Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese
              mitteilen. Hierbei kann es sich z.B. um Daten handeln, die Sie in
              ein Kontaktformular eingeben. Andere Daten werden automatisch beim
              Besuch der Website durch unsere IT-Systeme erfasst. Das sind vor
              allem technische Daten (z.B. Internetbrowser, Betriebssystem oder
              Uhrzeit des Seitenaufrufs). Die Erfassung dieser Daten erfolgt
              automatisch, sobald Sie unsere Website betreten.
            </p>
            <h4 class="isi-sub-heading-gray ">Wofür nutzen wir Ihre Daten?</h4>
            <p class="ml-0 mb-4">
              Ein Teil der Daten wird erhoben, um eine fehlerfreie
              Bereitstellung der Website zu gewährleisten. Andere Daten können
              zur Analyse Ihres Nutzerverhaltens verwendet werden.
            </p>
            <h4 class="isi-sub-heading-gray">
              Welche Rechte haben Sie bezüglich Ihrer Daten?
            </h4>
            <p class="ml-0 mb-4">
              Sie haben jederzeit das Recht unentgeltlich Auskunft über
              Herkunft, Empfänger und Zweck Ihrer gespeicherten
              personenbezogenen Daten zu erhalten. Sie haben außerdem ein Recht,
              die Berichtigung, Sperrung oder Löschung dieser Daten zu
              verlangen. Hierzu sowie zu weiteren Fragen zum Thema Datenschutz
              können Sie sich jederzeit unter der im Impressum angegebenen
              Adresse an uns wenden. Des Weiteren steht Ihnen ein
              Beschwerderecht bei der zuständigen Aufsichtsbehörde zu.
            </p>
            <h4 class="isi-sub-heading-gray">
              Analyse-Tools und Tools von Drittanbietern
            </h4>
            <p class="ml-0 mb-4">
              Beim Besuch unserer Website kann Ihr Surf-Verhalten statistisch
              ausgewertet werden. Das geschieht vor allem mit Cookies und mit
              sogenannten Analyseprogrammen. Die Analyse Ihres Surf-Verhaltens
              erfolgt in der Regel anonym; das Surf-Verhalten kann nicht zu
              Ihnen zurückverfolgt werden. Sie können dieser Analyse
              widersprechen oder sie durch die Nichtbenutzung bestimmter Tools
              verhindern. Detaillierte Informationen dazu finden Sie in der
              folgenden Datenschutzerklärung.<br><br>
                 Sie können dieser Analyse widersprechen. Über die
              Widerspruchsmöglichkeiten werden wir Sie in dieser
              Datenschutzerklärung informieren.
            </p>
            <h3 class="isi-heading-gray mb-4">
              2. Allgemeine Hinweise und Pflichtinformationen
            </h3>
            <h4 class="isi-sub-heading-gray">Datenschutz</h4>
            <p class="ml-0 mb-4">
              Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen
              Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten
              vertraulich und entsprechend der gesetzlichen
              Datenschutzvorschriften sowie dieser Datenschutzerklärung. Wenn
              Sie diese Website benutzen, werden verschiedene personenbezogene
              Daten erhoben. Personenbezogene Daten sind Daten, mit denen Sie
              persönlich identifiziert werden können. Die vorliegende
              Datenschutzerklärung erläutert, welche Daten wir erheben und wofür
              wir sie nutzen. Sie erläutert auch, wie und zu welchem Zweck das
              geschieht. Wir weisen darauf hin, dass die Datenübertragung im
              Internet (z.B. bei der Kommunikation per E-Mail) Sicherheitslücken
              aufweisen kann. Ein lückenloser Schutz der Daten vor dem Zugriff
              durch Dritte ist nicht möglich.
            </p>
            <h4 class="isi-sub-heading-gray">
              Hinweis zur verantwortlichen Stelle
            </h4>
            <p class="ml-0 mb-4">
              Die verantwortliche Stelle für die Datenverarbeitung auf dieser
              Website ist:
            </p>
            <ul style="list-style: none" class="mb-4">
              <li>Ascherberg 2</li>
              <li>37124 Rosdorf / Göttingen</li>
              <li>Telefon: +49 551 499 74 0</li>
              <li>E-Mail: mail@isi-insights.com</li>
            </ul>
            <p class="ml-0 mb-4">
              Verantwortliche Stelle ist die natürliche oder juristische Person,
              die allein oder gemeinsam mit anderen über die Zwecke und Mittel
              der Verarbeitung von personenbezogenen Daten (z.B. Namen,
              E-Mail-Adressen o. Ä.) entscheidet.
            </p>
            <h4 class="isi-sub-heading-gray">
              Widerruf Ihrer Einwilligung zur Datenverarbeitung
            </h4>
            <p class="ml-0 mb-4">
              Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen
              Einwilligung möglich. Sie können eine bereits erteilte
              Einwilligung jederzeit widerrufen. Dazu reicht eine formlose
              Mitteilung per E-Mail an uns. Die Rechtmäßigkeit der bis zum
              Widerruf erfolgten Datenverarbeitung bleibt vom Widerruf
              unberührt.
            </p>
            <h4 class="isi-sub-heading-gray">
              Beschwerderecht bei der zuständigen Aufsichtsbehörde
            </h4>
            <p class="ml-0 mb-4">
              Im Falle datenschutzrechtlicher Verstöße steht dem Betroffenen ein
              Beschwerderecht bei der zuständigen Aufsichtsbehörde zu.
              Zuständige Aufsichtsbehörde in datenschutzrechtlichen Fragen ist
              der Landesdatenschutzbeauftragte des Bundeslandes, in dem unser
              Unternehmen seinen Sitz hat. Eine Liste der
              Datenschutzbeauftragten sowie deren Kontaktdaten können folgendem
              Link entnommen werden:
              <a
                href="https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html"
                >https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html</a
              >.
            </p>

            <h4 class="isi-sub-heading-gray">Recht auf Datenübertragbarkeit</h4>
            <p class="ml-0 mb-4">
              Sie haben das Recht, Daten, die wir auf Grundlage Ihrer
              Einwilligung oder in Erfüllung eines Vertrags automatisiert
              verarbeiten, an sich oder an einen Dritten in einem gängigen,
              maschinenlesbaren Format aushändigen zu lassen. Sofern Sie die
              direkte Übertragung der Daten an einen anderen Verantwortlichen
              verlangen, erfolgt dies nur, soweit es technisch machbar ist.
            </p>

            <h4 class="isi-sub-heading-gray">SSL- bzw. TLS-Verschlüsselung</h4>
            <p class="ml-0 mb-4">
              Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der
              Übertragung vertraulicher Inhalte, wie zum Beispiel Bestellungen
              oder Anfragen, die Sie an uns als Seitenbetreiber senden, eine
              SSL-bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung
              erkennen Sie daran, dass die Adresszeile des Browsers von
              “http://” auf “https://” wechselt und an dem Schloss-Symbol in
              Ihrer Browserzeile. Wenn die SSL- bzw. TLS-Verschlüsselung
              aktiviert ist, können die Daten, die Sie an uns übermitteln, nicht
              von Dritten mitgelesen werden.
            </p>
            <h4 class="isi-sub-heading-gray">Auskunft, Sperrung, Löschung</h4>
            <p class="ml-0 mb-4">
              Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen
              jederzeit das Recht auf unentgeltliche Auskunft über Ihre
              gespeicherten personenbezogenen Daten, deren Herkunft und
              Empfänger und den Zweck der Datenverarbeitung und ggf. ein Recht
              auf Berichtigung, Sperrung oder Löschung dieser Daten. Hierzu
              sowie zu weiteren Fragen zum Thema personenbezogene Daten können
              Sie sich jederzeit unter der im Impressum angegebenen Adresse an
              uns wenden.
            </p>
            <h4 class="isi-sub-heading-gray">Widerspruch gegen Werbe-Mails</h4>
            <p class="ml-0 mb-4">
              Der Nutzung von im Rahmen der Impressumspflicht veröffentlichten
              Kontaktdaten zur Übersendung von nicht ausdrücklich angeforderter
              Werbung und Informationsmaterialien wird hiermit widersprochen.
              Die Betreiber der Seiten behalten sich ausdrücklich rechtliche
              Schritte im Falle der unverlangten Zusendung von
              Werbeinformationen, etwa durch Spam-E-Mails, vor.
            </p>
            <h3 class="isi-heading-gray mb-4">3. Datenschutzbeauftragter</h3>
            <h4 class="isi-sub-heading-gray">
              Gesetzlich vorgeschriebener Datenschutzbeauftragter
            </h4>
            <p class="ml-0 mb-4">
              Wir haben für unser Unternehmen einen Datenschutzbeauftragten
              bestellt.
            </p>
            <ul style="list-style: none" class="mb-4">
              <li>Ron Wieland</li>
              <li>Habichtswalderstr. 18</li>
              <li>34119 Kassel</li>
              <li>Telefon: +49 561 316 858 9</li>
              <li>E-Mail: wieland@dedata.de</li>
            </ul>
            <h3 class="isi-heading-gray mb-4">
              4. Datenerfassung auf unserer Website
            </h3>
            <h4 class="isi-sub-heading-gray">Cookies</h4>
            <p class="ml-0 mb-4">
              Die Internetseiten verwenden teilweise so genannte Cookies.
              Cookies richten auf Ihrem Rechner keinen Schaden an und enthalten
              keine Viren. Cookies dienen dazu, unser Angebot
              nutzerfreundlicher, effektiver und sicherer zu machen. Cookies
              sind kleine Textdateien, die auf Ihrem Rechner abgelegt werden und
              die Ihr Browser speichert.<br /><br />

              Die meisten der von uns verwendeten Cookies sind so genannte
              “Session-Cookies”. Sie werden nach Ende Ihres Besuchs automatisch
              gelöscht. Andere Cookies bleiben auf Ihrem Endgerät gespeichert
              bis Sie diese löschen. Diese Cookies ermöglichen es uns, Ihren
              Browser beim nächsten Besuch wiederzuerkennen.<br /><br />

              Sie können Ihren Browser so einstellen, dass Sie über das Setzen
              von Cookies informiert werden und Cookies nur im Einzelfall
              erlauben, die Annahme von Cookies für bestimmte Fälle oder
              generell ausschließen sowie das automatische Löschen der Cookies
              beim Schließen des Browser aktivieren. Bei der Deaktivierung von
              Cookies kann die Funktionalität dieser Website eingeschränkt
              sein.<br /><br />

              Cookies, die zur Durchführung des elektronischen
              Kommunikationsvorgangs oder zur Bereitstellung bestimmter, von
              Ihnen erwünschter Funktionen (z.B. Warenkorbfunktion) erforderlich
              sind, werden auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO
              gespeichert. Der Websitebetreiber hat ein berechtigtes Interesse
              an der Speicherung von Cookies zur technisch fehlerfreien und
              optimierten Bereitstellung seiner Dienste. Soweit andere Cookies
              (z.B. Cookies zur Analyse Ihres Surfverhaltens) gespeichert
              werden, werden diese in dieser Datenschutzerklärung gesondert
              behandelt.
            </p>
            <h4 class="isi-sub-heading-gray">Server-Log-Dateien</h4>
            <p class="ml-0 mb-4">
              Der Provider der Seiten erhebt und speichert automatisch
              Informationen in so genannten Server-Log-Dateien, die Ihr Browser
              automatisch an uns übermittelt. Dies sind:
            </p>
            <ul style="list-style: none" class="mb-4">
              <li>Browsertyp und Browserversion</li>
              <li>verwendetes Betriebssystem</li>
              <li>Referrer URL</li>
              <li>Hostname des zugreifenden Rechners</li>
              <li>Uhrzeit der Serveranfrage</li>
              <li>IP-Adresse</li>
            </ul>
            <p class="ml-0 mb-4">
              Eine Zusammenführung dieser Daten mit anderen Datenquellen wird
              nicht vorgenommen.<br />
              Grundlage für die Datenverarbeitung ist Art. 6 Abs. 1 lit. f
              DSGVO, der die Verarbeitung von Daten zur Erfüllung eines Vertrags
              oder vorvertraglicher Maßnahmen gestattet.
            </p>
            <h4 class="isi-sub-heading-gray">Kontaktformular</h4>
            <p class="ml-0">
              Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden
              Ihre Angaben aus dem Anfrageformular inklusive der von Ihnen dort
              angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für
              den Fall von Anschlussfragen bei uns gespeichert. Diese Daten
              geben wir nicht ohne Ihre Einwilligung weiter.<br /><br />

              Die Verarbeitung der in das Kontaktformular eingegebenen Daten
              erfolgt somit ausschließlich auf Grundlage Ihrer Einwilligung
              (Art. 6 Abs. 1 lit. a DSGVO). Sie können diese Einwilligung
              jederzeit widerrufen. Dazu reicht eine formlose Mitteilung per
              E-Mail an uns. Die Rechtmäßigkeit der bis zum Widerruf erfolgten
              Datenverarbeitungsvorgänge bleibt vom Widerruf unberührt.<br /><br />

              Die von Ihnen im Kontaktformular eingegebenen Daten verbleiben bei
              uns, bis Sie uns zur Löschung auffordern, Ihre Einwilligung zur
              Speicherung widerrufen oder der Zweck für die Datenspeicherung
              entfällt (z.B. nach abgeschlossener Bearbeitung Ihrer Anfrage).
              Zwingende gesetzliche Bestimmungen – insbesondere
              Aufbewahrungsfristen – bleiben unberührt.
            </p>
          </mdb-col>
        </mdb-row>
      </mdb-container>
    </section>
    <!-- ./SECTION-->
    <app-footer />
  </div>
</template>

<script>
import AppFooter from "../components/Footer.vue";
import { mdbSmooth } from "mdbvue";
export default {
  components: { AppFooter },
  directives: {
    mdbSmooth,
  },
  name: "DataPrivacy",
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: "Data Privacy",
    // all titles will be injected into this template
    titleTemplate: "%s | isi Test Studio Finder",
  },
};
</script>

<style scoped lang="scss">
@import "~@/styles/parts/_section.scss";

.data-privacy p {
  margin: 0.5rem;
  font-size: 1.1rem;
  font-family: "klavika";
}
</style>